'use strict';

/**
 * @ngdoc function
 * @name prepApp.controller:CourseTaskController
 * @description
 * # CourseTaskController
 * Controller of the prepApp
 */
angular.module('prepApp')
    .controller('CourseTaskController', function ($routeParams, APIs) {
        var vm = this;
        vm.selectedCourse = undefined;

        APIs.CourseService.get({ id: $routeParams.courseId }).$promise.then(function (data) {
            vm.selectedCourse = data;
        });
    });
